import ReactECharts from "echarts-for-react";
import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "states/DashboardContext";

function VituoVyaAfyaKwaMikoa() {
  const hook = useVituoVyaAfyaKwaMikoa();
  const words = useTranslations();

  const options = {
    title: {
      text: `${words.chartTitle}`,
      textStyle: {
        fontSize: "20",
      },
    },
    maintainAspectRatio: false,
    grid: {
      containLabel: true,
      left: "9%",
      bottom: "0%",
      right: "5%",
      top: "15%",
    },
    tooltip: { trigger: "axis" },
    toolbox: {
      show: true,
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    dataZoom: [
      { show: false },
      { type: "inside" },
      {
        show: false,
        yAxisIndex: 10,
        filterMode: "empty",
        width: 30,
        height: "70%",
        showDataShadow: false,
        left: "93%",
      },
    ],
    xAxis: {
      type: "category",
      data: ((regions) => {
        const dt = regions.map((region) => {
          return region.name;
        });
        return dt;
      })(hook.regionData),
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 90,
        fontSize: "16",
        fontWeight: "bold",
      },
    },
    yAxis: [
      {
        type: "value",
        nameLocation: "middle",
        nameGap: 50,
        axisLabel: {
          formatter: "{value}",
          show: true,
          interval: 0,
          rotate: 0,
          fontSize: "16",
          fontWeight: "800",
        },
      },
    ],
    series: [
      {
        type: "bar",
        name: "",
        barMaxWidth: 20,
        data: ((regions) => {
          const regionCounts = regions.map((region) => region.value);
          const dt = regionCounts.map((count, index) => {
            return {
              value: count,
              itemStyle: {
                color: "#1985A1",
              },
            };
          });
          return dt;
        })(hook.regionData),
      },
    ],
  };
  return (
    <div className="h-full text-[1.5vw] flex items-center justify-center">
      <div className="relative flex flex-col items-center justify-center w-full h-full gap-2">
        {hook.regionData && (
          <ReactECharts
            style={{ height: "60vh", minHeight: 200, width: "100%" }}
            option={options}
          />
        )}
      </div>
    </div>
  );
}

export default VituoVyaAfyaKwaMikoa;

const useTranslations = () => {
  const { languageState } = useContext(DashboardContext);
  const [language] = languageState;

  return {
    chartTitle: language
      ? "Number of Health Centers by region"
      : "Idadi ya Vituo vya Afya kwa Mikoa",
    chartYAxis: language ? "Number" : "Idadi",
    language,
  };
};

const useVituoVyaAfyaKwaMikoa = () => {
  const censusYears = [1967, 1978, 1988, 2002, 2012, 2022];
  const lastIndex = censusYears.length - 1;
  const [selectedYearIndex, setSelectedYearIndex] = useState(lastIndex);
  const censusYear = censusYears[selectedYearIndex];
  const previousCensusYear = censusYears[selectedYearIndex - 1] ?? null;
  const nextCensusYear = censusYears[selectedYearIndex + 1] ?? null;

  // year change handlers
  const handleNext = () => {
    if (selectedYearIndex === lastIndex) return;
    setSelectedYearIndex((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (selectedYearIndex === 0) return;
    setSelectedYearIndex((prev) => prev - 1);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const _data = regionDataGenerator(censusYear);
    setData((prev) => {
      prev = _data;
      return prev;
    });
  }, [selectedYearIndex]);

  return {
    regionData: data,
    selectedYearIndex,
    lastIndex,
    handleNext,
    handlePrevious,
    censusYear,
    previousCensusYear,
    nextCensusYear,
  };
};

const regionDataGenerator = (year) => {
  return [
    { name: "Dodoma", value: 69 },
    { name: "Arusha", value: 76 },
    { name: "Kilimanjaro", value: 66 },
    { name: "Tanga", value: 64 },
    { name: "Morogoro", value: 73 },
    { name: "Pwani", value: 57 },
    { name: "Dar es Salaam", value: 154 },
    { name: "Lindi", value: 34 },
    { name: "Mtwara", value: 38 },
    { name: "Ruvuma", value: 50 },
    { name: "Iringa", value: 47 },
    { name: "Mbeya", value: 73 },
    { name: "Singida", value: 30 },
    { name: "Tabora", value: 40 },
    { name: "Rukwa", value: 37 },
    { name: "Kigoma", value: 46 },
    { name: "Shinyanga", value: 46 },
    { name: "Kagera", value: 59 },
    { name: "Mwanza", value: 103 },
    { name: "Mara", value: 55 },
    { name: "Manyara", value: 38 },
    { name: "Njombe", value: 44},
    { name: "Katavi", value: 25 },
    { name: "Simiyu", value: 28 },
    { name: "Geita", value: 43 },
    { name: "Songwe", value: 35 },
    { name: "Mjini Magharibi", value: 9 },
    { name: "Kaskazini Pemba", value: 6 },
    { name: "Kusini Pemba", value: 8 },
    { name: "Kaskazini Unguja", value: 8 },
    { name: "Kusini Unguja", value: 5 },
  ]
    .sort((a, b) => (a.value < b.value ? 1 : -1))
    .map((dt) => ({ ...dt, value: dt.value }));
};
